import PropTypes from 'prop-types'
import React from 'react'
import FormErrors from 'components/form-components/form-errors'
import { StyledTextInput } from 'components/form-components/styled-text-input'

const propTypes = {
  autoComplete: PropTypes.string,
  changeAction: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
  content: PropTypes.string,
  maxLength: PropTypes.number,
  model: PropTypes.string.isRequired,
  onKeyPress: PropTypes.func,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  type: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  updateOn: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  validateOn: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  validators: PropTypes.shape({}),
}

const defaultProps = {
  autoComplete: null,
  changeAction: undefined,
  children: undefined,
  className: null,
  content: null,
  maxLength: null,
  onKeyPress: undefined,
  placeholder: null,
  readOnly: false,
  updateOn: 'change',
  validateOn: 'change',
  validators: undefined,
  onChange: undefined,
}

function Input(props) {
  const {
    autoComplete,
    changeAction,
    children,
    className,
    content,
    maxLength,
    model,
    onKeyPress,
    placeholder,
    readOnly,
    type,
    updateOn,
    onChange,
    validateOn,
    validators,
  } = props
  return (
    <div className={className}>
      {content}
      <StyledTextInput
        model={model}
        validators={validators}
        validateOn={validateOn}
        updateOn={updateOn}
        changeAction={changeAction}
        onKeyPress={onKeyPress}
        onChange={onChange}
        type={type}
        placeholder={placeholder}
        disabled={readOnly}
        maxLength={maxLength}
        autoComplete={autoComplete}
      />
      {children}
      <FormErrors model={model} />
    </div>
  )
}

Input.propTypes = propTypes

Input.defaultProps = defaultProps

export default Input
